import React, { useState } from "react";
import * as XLSX from "xlsx";
import { Table, Card, Typography } from "antd";

const { Title } = Typography;

const AboutElectionsUpload = ({ onDataExtracted }) => {
  const [data, setData] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      if (jsonData.length === 0) return;

      let geographicalArea = "";
      let electedCandidate = [];
      let startIndex = -1;

      for (let i = 0; i < jsonData.length; i++) {
        const row = jsonData[i];

        if (row[0]?.toString().toLowerCase().includes("area")) {
          geographicalArea = row[1]?.trim() || "Unknown Area";
          continue;
        }

        if (row.length >= 5 && !isNaN(row[1]) && parseInt(row[1]) > 1900) {
          startIndex = i;
          break;
        }
      }

      if (startIndex !== -1) {
        for (let i = startIndex; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (row.length >= 5 && !isNaN(row[1])) {
            const year = row[1]?.toString().trim();
            const candidate = row[2]?.toString().trim();
            const party = row[3]?.toString().trim();
            let percentage = parseFloat(row[4]);

            if (!isNaN(percentage)) {
              percentage = (percentage * 100).toFixed(2) + "%"; // Convert to percentage format
            } else {
              percentage = "N/A"; // Handle invalid values
            }

            if (year && candidate && party && percentage) {
              electedCandidate.push({ year, candidate, party, percentage });
            }
          }
        }
      }

      setData({ geographicalArea, electedCandidate });
      onDataExtracted({ geographicalArea, electedCandidate });
    };

    reader.readAsArrayBuffer(file);
  };

  const columns = [
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Candidate Name",
      dataIndex: "candidate",
      key: "candidate",
    },
    {
      title: "Party",
      dataIndex: "party",
      key: "party",
    },
    {
      title: "Vote Share %",
      dataIndex: "percentage",
      key: "percentage",
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      {data && (
        <Card style={{ marginTop: "20px" }}>
          <Title level={4}>Geographical Area</Title>
          <p>{data.geographicalArea}</p>
          <Title level={4} style={{ marginTop: "20px" }}>
            Election Results
          </Title>
          <Table
            dataSource={data.electedCandidate}
            columns={columns}
            rowKey="year"
            pagination={{ pageSize: 5 }}
          />
        </Card>
      )}
    </div>
  );
};

export default AboutElectionsUpload;
